import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';
import {
  CompFieldConfig,
  CompFields,
  CompFieldsArgs,
  CompFieldsTableCellProps,
} from '@hcs/types';
import { formatDistanceMiles } from '@hcs/utils';

const FIELD = CompFields.distance;
type FieldConfig = CompFieldConfig<typeof FIELD>;
const label = 'Distance';
const labelShort = 'Distance';
const compPath: FieldConfig['compPath'] = '/distance';
const getValue: FieldConfig['getValue'] = (comp) => comp?.distance;
const formatValue: FieldConfig['formatValue'] = (comp) =>
  formatDistanceMiles(getValue(comp));

// For displaying multiple fields in a single line
const labelMicro: FieldConfig['labelMicro'] = 'Distance';
const formatValueShort: FieldConfig['formatValueShort'] = (propertyStateArgs) =>
  formatDistanceMiles(getValue(propertyStateArgs));

const formatInline: FieldConfig['formatInline'] = (comp) =>
  formatDistanceMiles(getValue(comp));

// Component for displaying a field from a comp
// eslint-disable-next-line react-refresh/only-export-components
const Display = ({ comp }: CompFieldsArgs) => {
  return <>{formatDistanceMiles(comp?.distance)}</>;
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = (props: TableHeaderCellProps) => {
  return <TableHeaderCell {...props}>{labelShort}</TableHeaderCell>;
};
// Using default props allows for child.props checks
// in the Table components to work properly
const defaultHeaderProps: Partial<TableHeaderCellProps> = {
  align: 'right',
  // Needed so child component type-checking passes
  isTableHeaderCell: true,
};
HeaderCell.defaultProps = defaultHeaderProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({ comp, ...tableCellProps }: CompFieldsTableCellProps) => {
  return (
    <TableCell {...tableCellProps}>
      <Display comp={comp} />
    </TableCell>
  );
};
// Using default props allows for child.props checks
// in the Table components to work properly
const defaultContentProps: Partial<TableCellProps> = {
  align: 'right',
  // Needed so child component type-checking passes
  isTableCell: true,
};
ContentCell.defaultProps = defaultContentProps;

export const DISTANCE_CONFIG: FieldConfig = {
  field: FIELD,
  label,
  labelShort,
  compPath,
  getValue,
  formatValue,
  labelMicro,
  formatValueShort,
  formatInline,
  HeaderCell,
  ContentCell,
  Display,
};
